import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { User, Building2, Home } from "lucide-react";

export default function ChooseRole() {
  const { user, setRole } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  if (user && !user.needs_role) { navigate("/", { replace: true }); return null; }

  const pick = async (role) => {
    setSaving(true);
    try {
      const u = await setRole(role);
      toast.success("All set!");
      navigate(u.role === "broker" ? "/broker" : "/browse", { replace: true });
    } catch (e) {
      toast.error("Could not save. Try again.");
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-20" data-testid="choose-role">
      <div className="w-12 h-12 rounded-xl bg-brand-emerald flex items-center justify-center mb-5">
        <Home className="w-6 h-6 text-white" />
      </div>
      <h1 className="font-heading font-bold text-2xl text-brand-ink">One last step</h1>
      <p className="text-brand-muted mt-1 mb-6">Tell us how you'll use My Property</p>
      <div className="grid grid-cols-2 gap-4">
        {[{ v: "customer", icon: User, l: t("auth.customer"), d: "Browse & enquire" }, { v: "broker", icon: Building2, l: t("auth.broker"), d: "List properties" }].map((r) => (
          <button
            key={r.v}
            disabled={saving}
            onClick={() => pick(r.v)}
            data-testid={`choose-${r.v}`}
            className="flex flex-col items-center gap-2 p-6 rounded-2xl border border-brand-line hover:border-brand-emerald hover:bg-brand-emerald/5 transition-colors disabled:opacity-50"
          >
            <r.icon className="w-7 h-7 text-brand-emerald" />
            <span className="font-heading font-semibold text-brand-ink">{r.l}</span>
            <span className="text-xs text-brand-muted">{r.d}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
